// useEdgeHandler.ts
import {
  useReactFlow,
  Edge,
  Connection,
  addEdge,
  useUpdateNodeInternals,
  MarkerType,
} from '@xyflow/react'
import { useCallback } from 'react'
import { useIncompleteEdge } from './useIncompleteEdge'

export function useEdgeHandler() {
  const { setEdges, getNode } = useReactFlow()
  const updateNodeInternals = useUpdateNodeInternals()
  const incompleteEdgeHandlers = useIncompleteEdge()

  const onConnect = useCallback(
    (params: Connection | Edge) => {
      if (
        !params ||
        typeof params !== 'object' ||
        !params.source ||
        !params.target
      ) {
        console.error('Invalid connection params:', params)
        return
      }

      const sourceNode = getNode(params.source)
      const targetNode = getNode(params.target)

      if (!sourceNode || !targetNode) {
        return
      }

      // Check if the source is an annotation node
      if (sourceNode.type === 'annotationnode') {
        return
      }

      // Handle normal edges
      const edgeType = 'floating'
      const edgeData = {
        animated: true,
        pattern: 'dashed',
        direction: 'forward',
        color: '#b1b1b7'
      }

      if (params.source.startsWith('SmartNotes')) {
        edgeData.color = '#ff0072'
      } else if (params.source.startsWith('Modifier')) {
        edgeData.color = '#00ff72'
      } else if (params.source.startsWith('Cell')) {
        edgeData.color = '#0072ff'
      } else if (params.source.startsWith('ChatAI')) {
        edgeData.color = '#7200ff'
      }

      // Create edge without handles
      const newEdge: Edge = {
        id: `${params.source}-${params.target}`,
        source: params.source,
        target: params.target,
        type: edgeType,
        data: edgeData,
        animated: true,
        markerEnd: {
          type: MarkerType.Arrow,
        }
      }

      setEdges((eds) => addEdge(newEdge, eds))
    },
    [setEdges, getNode]
  )

  return {
    ...incompleteEdgeHandlers,
    onConnect,
  }
}
